<template>
  <form>
    <div class="settings-top-bar" ref="optionsTopBar">
      <div class="top-bar">
       <p>
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="cancelZone">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
       </p>
       <p class="d-inline-flex">
          <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" v-if="!isNew" @click.prevent="deleteZone" style="padding: 7px 10px; margin-right: 20px;">
            <img src="/static/img/icons/icon-close.png">
            {{$t('general.delete')}}
          </a>
          <button type="submit" class="btn btn-icon btn-success btn mar-rt-10 save"  @click.prevent="validate" :title="$t('general.save') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>
    <div class="row mar-to-15" style="display: flex; justify-content: flex-start; align-items: stretch;">
      <div class="col-lg-12 col-md-12">
        <div class="card" style="height:100%; width:100%; margin: 0;">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg><!---->
            </div>
          </div>
          <div class="card-content">
            <p class="text-danger" v-if="errors.has('error')">
              {{ getError('error') }}
            </p>
            <div class="row">
              <div class="col-md-12">
                 <div class="form-group">
                  <p>ID: {{model.id}}</p>
                </div>
                <div class="form-group">
                  <label>{{$t('settingTable.name')}}</label>
                  <input type="text"
                          name="name"
                          data-vv-as="name"
                          :placeholder="$t('settingTable.name')"
                          v-validate="modelValidate.name"
                          v-model="model.name"
                          class="form-control">
                  <small class="text-danger" v-if="errors.has('name')">
                    {{ getError('name') }}
                  </small>
                </div>
                <div class="form-group">
                  <label>{{$t('settingTable.short')}}</label>
                  <input type="text"
                          name="short"
                          data-vv-as="short"
                          :placeholder="$t('settingTable.short')"
                          v-validate="modelValidate.short"
                          v-model="model.short"
                          class="form-control">
                  <small class="text-danger" v-if="errors.has('short')">
                    {{ getError('short') }}
                  </small>
                </div>
                <div class="form-group">
                  <label>{{$t('settingTable.short_spv')}}</label>
                  
                  <input 
                    type="hidden" 
                    name="short_spv" 
                    v-validate="'required'" 
                    data-vv-as="short_spv"
                    v-model="model.short_spv">

                  <v-select
                      v-model="model.short_spv"
                      :options="unitOptions"
                      label="text"
                      :placeholder="$t('settingTable.short_spv')"
                      :searchable="true">
                  </v-select>

                  <small class="text-danger" v-if="errors.has('short_spv')">
                    {{ getError('short_spv') }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12 col-md-12">
        <div class="card" style="height:100%; width:100%; margin: 0;">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg><!---->
            </div>
          </div>
          <div class="card-content">
            <p class="text-danger" v-if="errors.has('error')">
              {{ getError('error') }}
            </p>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <div style="margin-bottom: 20px">
                  <!-- <label>{{$t('settingTable.unitConversions')}}</label> -->
                  <button @click.prevent="addConversion" class="btn btn-sm btn-outline-primary">
                    <i class="ti-plus"></i> {{$t('general.addConversion')}}
                  </button>
                  </div>
                  <div v-for="(conversion, index) in model.unit_calc" :key="index" class="d-flex align-items-center mb-2" style="margin-bottom: 20px;">
                    <select 
                        v-model="model.unit_calc[index].unit_id" 
                        @change="onUnitChange(index)"
                        class="form-control mr-2" 
                        style="max-width: 300px; margin-right: 10px;"
                      >
                      <option :value="null" disabled>{{$t('general.selectUnit')}}</option>
                      <option v-for="unit in allUnits" :value="unit.id" :key="unit.id" :disabled="isUnitAlreadyUsed(unit.id, index)">
                        {{ unit.name }} ({{ unit.short }}) 
                      </option>
                    </select>
                    <input v-model.number="conversion.value" type="number" class="form-control mr-2" style="width: 200px; margin-right: 10px;" placeholder="Valoare">
                    <button @click.prevent="removeConversion(index)" class="btn btn-sm btn-danger" style="width: 35px; height: 35px; padding: 0;">
                      <i class="ti-close"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
/* eslint-disable */
  import Vue from 'vue'
  // import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker} from 'element-ui'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)

  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [Upload.name]: Upload,
      [Button.name]: Button,
      [Input.name]: Input
    },
    props: {
      zoneId: null,
      callback: {
        required: false
      }
    },
    watch: {
      zoneId (value) {
        this.id = value
      }
    },
    computed: {
      unitOptions() {
        return Object.values(this.unitMapping);
      }
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
      this.getData()
      this.getAllUnits()
    },
    data () {
      return {
        apiUrl: '',
        id: this.value || this.zoneId,
        isNew: true,
        allUnits: [],
        model: {
          'id': 0,
          'name': '',
          'short': '',
          'short_spv': null,
          'unit_calc': []
        },
        modelValidate: {
          name: {required: true},
          short: {required: true},
          short_spv: {required: true},
          // firstname: {required: true, min: 3},
        },
        languages: this.$session.get('defaultData')['available_languages'],
        loading: true
      }
    },
    methods: {
      addConversion () {
        let mod = this.model
        this.model = null
        mod.unit_calc.push({
          unit_id: null,
          value: null,
          name: '',
          short: ''
        })
        this.model = mod
      },
      removeConversion (index) {
        let mod = this.model
        this.model = null
        mod.unit_calc.splice(index, 1)
        this.model = mod
      },
      onUnitChange (index) {
        let mod = this.model
        this.model = null
        const selectedId = mod.unit_calc[index].unit_id
        const unit = this.allUnits.find(u => u.id === selectedId)
        if (unit) {
          Object.assign(mod.unit_calc[index], {
            name: unit.name,
            short: unit.short
          })
        }
        this.model = mod
      },
      isUnitAlreadyUsed(unit_id, currentIndex) {
        if (unit_id == null) return false;

        return this.model.unit_calc.some((conversion, index) => {
          return index !== currentIndex && conversion.unit_id === unit_id;
        });
      },
      getData () {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        if ((this.$route.params.id !== undefined && this.$route.params.id) ||
          (this.id !== undefined && this.id !== null)) {
          this.isNew = false
        } else {
          this.isNew = true
        }
        if (!this.isNew) {
          var id = this.$route.params.id || this.id
          this.apiRequest('/measurements-units/' + id, 'GET', data, (response) => {
            if (response.status === true) {
              response.data.short_spv = this.unitMapping[response.data.short_spv]
              this.model = response.data
              if (!this.model.unit_calc) {
                this.model.unit_calc = []
              }
              this.loading = false
            }
          })
        } else {
          this.loading = false
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) { this.saveZone() }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            if (errors[prop].length === 1) {
              this.errors.add(prop, errors[prop][0])
            } else {
              this.errors.add(prop, errors[prop])
            }
          } else {
            this.errors.add('error', errors[prop])
          }
        }
      },
      getAllUnits () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/measurements-units', 'GET', data, (response) => {
          if (response.status === true) {
            this.allUnits = response.data.filter(unit => unit.id !== this.model.id);
          }
        })
      },
      saveZone () {
        this.loading = true
        let data = this.model
        if (data.short_spv && data.short_spv.value) {
          data.short_spv = data.short_spv.value
        }
        data.token = this.$session.get('token')
        data.company_id = this.$session.get('selectedCompany')
        this.apiRequest('/measurements-units/' + data.id, 'PUT', data, (response) => {
          if (response.success === true) {
            this.loading = false
            this.errors.clear()
            swal(
              {
                title: '',
                text: this.$t('settingTable.tableSave'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }
            )
            .then(() => {})
            .catch(() => {})
            this.cancelZone()
          } else {
            this.loading = false
            this.handleErrors(response.errors)
          }
        })
      },
      deleteZone () {
        var btnCounter = 1
        var self = this
        swal({
          title: self.$t('settingTable.deleteZoneTitle'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes (' + btnCounter + ')'
        })
        .then((result) => {
          if (result) {
            this.deleteZone2()
          }
        })
        swal.disableConfirmButton()

        var btnInterval = setInterval(function () {
          btnCounter--

          if (btnCounter >= 1) {
            swal.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')'
          } else {
            swal.getConfirmButton().textContent = self.$t('general.yes')
            clearInterval(btnInterval)
            swal.enableConfirmButton()
          }
        }, 1000)
      },
      deleteZone2 () {
        this.loadingReset = true
        var id = this.id || this.$route.params.id
        var data = {
          company_id: this.$session.get('selectedCompany'),
          token: this.$session.get('token'),
          delete: true
        }
        this.apiRequest('/measurements-units/' + id, 'PUT', data, (response) => {
          if (response.success === true) {
            this.loadingReset = false
            swal({'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
            this.cancelZone()
          } else {
            this.loadingReset = false
            swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
          }
        })
      },
      cancelZone () {
        if (typeof this.callback === 'function') {
          this.callback()
        }
      }
    }
  }
</script>
<style>
  /* secret hidden css start */



  /* secret hidden css stop */
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/MeasurementsUnits/MeasurementsUnitsForm.vue